import script from "./PdfViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PdfViewer.vue?vue&type=script&lang=ts&setup=true"

import "./PdfViewer.vue?vue&type=style&index=0&id=7a0fe360&lang=css"
import "./PdfViewer.vue?vue&type=style&index=1&id=7a0fe360&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0fe360"]])

export default __exports__